import type { ICustomControlRequestReadProps } from '../../interfaces/customControlRequestReadProps';
import { translateKey } from '../../../../../translate';
import { UserTextParagraph } from '../../../../elements/common';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { FormSection } from '../../../../elements/forms/formSection/FormSection';
import { HorizontalFormGroupRead } from '../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../elements/forms/InputContainer';
import { Icd10SelectionsRead } from '../../utils/v1/Icd10/Icd10SelectionsRead';

export function QuestionRead(props: ICustomControlRequestReadProps) {
    const isVisible =
        props.request.customControlData.vraag ||
        props.request.customControlData.toelichting ||
        props.request.customControlData.conclusie_diagnose ||
        props.request.diagnosis?.diagnosisConsiderationIcd10 ||
        props.request.diagnosis?.diagnosisDifferentialConsiderationIcd10a;

    if (!isVisible) {
        return null;
    }

    return (
        <FormSection
            isBorderLess
            title={isVisible ? translateKey('request.question') : ''}
        >
            {props.request.customControlData.vraag && (
                <HorizontalFormGroupRead>
                    <FormLabel>{translateKey('request.question')}</FormLabel>
                    <InputContainer>
                        <UserTextParagraph>{props.request.customControlData.vraag}</UserTextParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}

            <Icd10SelectionsRead
                diagnosis={props.request.diagnosis}
                diagnosisConclusion={props.request.customControlData?.conclusie_diagnose}
                hideTitle
                showWorkingDiagnosis
                thesaurusTermDate={props.request.dateSent}
            />

            {props.request.customControlData.toelichting && (
                <HorizontalFormGroupRead>
                    <FormLabel>{translateKey('common.remarks')}</FormLabel>
                    <InputContainer>
                        <UserTextParagraph>{props.request.customControlData.toelichting}</UserTextParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}
        </FormSection>
    );
}
